import { background, defineStyleConfig } from '@chakra-ui/react';

export const tabsTheme = defineStyleConfig({
  baseStyle: {
    tab: {
      color: 'text.primary',
      fontWeight: 'medium',
      _selected: {
        color: 'accent.default',
        backgroundColor: 'accent.lightest',
        fontWeight: 'medium',
      },
      _hover: {
        color: 'accent.default',
      },
    },
  },
  variants: {
    secondaryNav: {
      tab: {
        color: 'text.primary',
        bg: 'transparent',
        fontWeight: 'medium',
        outline: '2px solid transparent',
        outlineOffset: '2px',
        borderBottom: '2px solid transparent',
        display: 'flex',
        flexDir: ['column', 'column', 'row'],
        alignItems: 'center',
        justifyContent: 'center',
        _selected: {
          color: 'accent.default',
          bg: 'transparent',
          borderColor: 'accent.default',
        },
        _disabled: {
          _hover: {
            color: 'inherit',
          },
        },
      },
      tablist: {
        borderBottom: '2px solid',
        borderColor: 'inherit',
      },
      tabpanel: {
        px: 0,
        py: 4,
      },
    },
  },
});
